import type { ReactNode } from 'react'
import React from 'react'
import { useContext } from './Context'
import styles from './styles.module.scss'
import isNil from 'lodash/isNil'
import isFunction from 'lodash/isFunction'

export type StepProps = {
  onClick: () => Promise<void>
  children: ReactNode
  stepKey: number
  canStep?: boolean | ((activePanel: number) => boolean)
}
export const Step = (stepProps: StepProps) => {
  const { getClassName, canRun, activeStep } = useContext()

  const canRunStep = () => {
    let canStepResult = true
    if (isNil(canStepResult)) {
      canStepResult = isFunction(stepProps.canStep) ? stepProps.canStep(activeStep) : stepProps.canStep
    }

    return canRun(stepProps.stepKey) && canStepResult
  }

  return (
    <div
      className={`${styles.step} ${getClassName(stepProps.stepKey)} `}
      onClick={async () => {
        if (canRunStep()) await stepProps.onClick()
      }}
    >
      <span>{stepProps.children}</span>
    </div>
  )
}
